export const actionTimeControl = {
    checkField: ['Проверьте поля «{{fields}}» ', 'Please check «{{fields}}» fields'],
    checkTimeField: ['Проверьте, что все поля времени заполнены правильно', 'Please check that all time fields are entered correctly'],
    checkTwoField: ['Проверьте поля «{{fieldA}}» и «{{fieldB}}»', 'Please check «{{fieldA}}» and «{{fieldB}}» fields'],
    chronologicalBroken: ['Хронологическая последовательность операций нарушена', 'The chronological sequence of operations is broken'],
    details: ['подробнее', 'details'],
    editTime: ['Изменить время', 'Edit time'],
    timesIncorect: ['Некоторые из введённых значений времени неверные', 'Some of the entered times are incorrect.'],
    titleDialog: ['Диалог {{title}}', '{{title}} dialog'],
};
